<app-navbar></app-navbar>
<div class="container py-5">
  <h2 style="margin-bottom: 25px;">{{ 'PRIVACY_POLICY.TITLE' | translate }}</h2>
  <div class="row">
    <div class="col-md-12">
      <mat-card [appearance]="'outlined'">
        <mat-card-content>

          <p>{{ 'PRIVACY_POLICY.INTRO.PARAGRAPH1' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.INTRO.PARAGRAPH2' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.INTRO.PARAGRAPH3' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.INTRO.PARAGRAPH4' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION1.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION1.DESCRIPTION' | translate }}</p>
          <ul>
            <li>
              {{ 'PRIVACY_POLICY.SECTION1.CONTACT_LABEL' | translate }}
              <a href="mailto:pradacademy.cr@gmail.com">{{ 'PRIVACY_POLICY.SECTION1.CONTACT_VALUE' | translate }}</a>
            </li>
            <li>
              {{ 'PRIVACY_POLICY.SECTION1.WEBSITE_LABEL' | translate }}
              <a href="https://pradacademy.com" target="_blank">{{ 'PRIVACY_POLICY.SECTION1.WEBSITE_VALUE' | translate }}</a>
            </li>
          </ul>

          <h4>{{ 'PRIVACY_POLICY.SECTION2.TITLE' | translate }}</h4>
          <h5>{{ 'PRIVACY_POLICY.SECTION2.A.TITLE' | translate }}</h5>
          <ul>
            <li>{{ 'PRIVACY_POLICY.SECTION2.A.ITEM1' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION2.A.ITEM2' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION2.A.ITEM3' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION2.A.ITEM4' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION2.A.ITEM5' | translate }}</li>
          </ul>
          <h5>{{ 'PRIVACY_POLICY.SECTION2.B.TITLE' | translate }}</h5>
          <ul>
            <li>{{ 'PRIVACY_POLICY.SECTION2.B.ITEM1' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION2.B.ITEM2' | translate }}</li>
          </ul>

          <h4>{{ 'PRIVACY_POLICY.SECTION3.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION3.DESCRIPTION' | translate }}</p>
          <ul>
            <li>{{ 'PRIVACY_POLICY.SECTION3.ITEM1' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION3.ITEM2' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION3.ITEM3' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION3.ITEM4' | translate }}</li>
          </ul>

          <h4>{{ 'PRIVACY_POLICY.SECTION4.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION4.DESCRIPTION' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION5.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION5.PARAGRAPH1' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.SECTION5.PARAGRAPH2' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.SECTION5.PARAGRAPH3' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION6.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION6.PARAGRAPH1' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.SECTION6.PARAGRAPH2' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.SECTION6.PARAGRAPH3' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION7.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION7.DESCRIPTION' | translate }}</p>
          <ul>
            <li><strong>{{ 'PRIVACY_POLICY.SECTION7.RIGHT_ACCESS_1' | translate }}</strong> {{ 'PRIVACY_POLICY.SECTION7.RIGHT_ACCESS' | translate }}</li>
            <li><strong>{{ 'PRIVACY_POLICY.SECTION7.RIGHT_RECTIFY_1' | translate }}</strong> {{ 'PRIVACY_POLICY.SECTION7.RIGHT_RECTIFY' | translate }}</li>
            <li><strong>{{ 'PRIVACY_POLICY.SECTION7.RIGHT_DELETE_1' | translate }}</strong> {{ 'PRIVACY_POLICY.SECTION7.RIGHT_DELETE' | translate }}</li>
          </ul>
          <p>
            {{ 'PRIVACY_POLICY.SECTION7.CONTACT_PREFIX' | translate }}
            <a href="mailto:pradacademy.cr@gmail.com">{{ 'PRIVACY_POLICY.SECTION7.CONTACT_EMAIL' | translate }}</a>
            {{ 'PRIVACY_POLICY.SECTION7.CONTACT_SUFFIX' | translate }}
          </p>
          <p>{{ 'PRIVACY_POLICY.SECTION7.RESPONSE' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION8.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION8.DESCRIPTION' | translate }}</p>
          <ul>
            <li>{{ 'PRIVACY_POLICY.SECTION8.ITEM1' | translate }}</li>
            <li>{{ 'PRIVACY_POLICY.SECTION8.ITEM2' | translate }}</li>
          </ul>
          <p>{{ 'PRIVACY_POLICY.SECTION8.PARAGRAPH' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION9.TITLE' | translate }}</h4>
          <p>{{ 'PRIVACY_POLICY.SECTION9.PARAGRAPH1' | translate }}</p>
          <p>{{ 'PRIVACY_POLICY.SECTION9.PARAGRAPH2' | translate }}</p>
          <p><strong>{{ 'PRIVACY_POLICY.SECTION9.LAST_UPDATE_LABEL' | translate }}</strong> {{ 'PRIVACY_POLICY.SECTION9.LAST_UPDATE_VALUE' | translate }}</p>

          <h4>{{ 'PRIVACY_POLICY.SECTION10.TITLE' | translate }}</h4>
          <ul>
            <li>📧 {{ 'PRIVACY_POLICY.SECTION10.EMAIL_LABEL' | translate }} <a href="mailto:pradacademy.cr@gmail.com">{{ 'PRIVACY_POLICY.SECTION10.EMAIL_VALUE' | translate }}</a></li>
            <li>🌐 {{ 'PRIVACY_POLICY.SECTION10.WEBSITE_LABEL' | translate }} <a href="https://pradacademy.com" target="_blank">{{ 'PRIVACY_POLICY.SECTION10.WEBSITE_VALUE' | translate }}</a></li>
            <li>🏛️ {{ 'PRIVACY_POLICY.SECTION10.ENTITY_LABEL' | translate }} {{ 'PRIVACY_POLICY.SECTION10.ENTITY_VALUE' | translate }}</li>
          </ul>

        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<app-footer></app-footer>
